import React from 'react';
export function Footer() {
  return <footer className="bg-background py-8 border-t border-border" data-id="element-81" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-82" data-mp="3gfitaf6445cj">
        <div className="text-xl font-semibold tracking-tight text-primary" data-id="element-83" data-mp="32ovvqqc38li1">
          Юридичний захист / Юридична компанія
        </div>

        <div className="flex gap-6 text-sm text-secondary" data-id="element-84" data-mp="36nd75m2jki59">
          <a href="#" className="hover:text-primary transition-colors" data-id="element-85" data-mp="3ug3bpa847z5i">
            Telegram
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-86" data-mp="37fv17ktl04a">
            Viber
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-87" data-mp="3ldu5gwjvqrxx">
            Facebook
          </a>
        </div>

        <div className="text-sm text-secondary" data-id="element-88" data-mp="3qfjiuiukrhp6">
          &copy; 2026 Всі права захищені.
        </div>
      </div>
    </footer>;
}